import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import store from "./redux/store";
import "./App.css";
import './index.css';
import router from "./routes/router";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="573574406186-ea3mkhrk389i039nhuj4ovarf0os4329.apps.googleusercontent.com">
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
  </GoogleOAuthProvider>
);